require('./ui/common.js');
require('./ui/swiper_init.js');
require('./ui/ajax-forms.js');
require('./ui/popup.js');

// Init classes
Popup.init();
